$(document).ready(function () {
    var mediaSmartphone = 'mediaSmartphone',
        mediaTablet = 'mediaTablet',
        mediaDesktop = 'mediaDesktop';

    var jRes = jRespond([
        {
            label: 'smartphone',
            enter: 0,
            exit: 767
        }, {
            label: 'tablet',
            enter: 768,
            exit: 1279
        }, {
            label: 'desktop',
            enter: 1280,
            exit: 10000
        }
    ]);

    jRes.addFunc([
        {
            breakpoint: 'smartphone',
            enter: function () {
                myInitFuncSmartphone();

            },
            exit: function () {
            }
        },
        {
            breakpoint: 'tablet',
            enter: function () {
                myInitFuncTablet();

            },
            exit: function () {
            }
        },
        {
            breakpoint: 'desktop',
            enter: function () {
                myInitFuncDesktop();

            },
            exit: function () {
            }
        }
    ]);

    function myInitFuncSmartphone() {
        menuStratis(mediaSmartphone); // 190_stratis_menu.js
        fancyboxGalerie(mediaSmartphone); // 230_stratis_fancybox_galerie.js
        initGalerieClassique(mediaSmartphone); // 240_ stratis_galerie_classique.js
        searchState(mediaSmartphone); // 290_stratis_search.js
        filtersState(mediaSmartphone); // 300_stratis_filters.js
        carrousel1State(mediaSmartphone); // 330_stratis_carrousel1.js
        carrousel2State(mediaSmartphone); // 340_stratis_carrousel2.js
        carrousel3State(mediaSmartphone); // 350_stratis_carrousel5.js
        menuMain1State(mediaSmartphone);
    }

    function myInitFuncTablet() {
        menuStratis(mediaTablet); // 190_stratis_menu.js
        fancyboxGalerie(mediaTablet); // 230_stratis_fancybox_galerie.js
        initGalerieClassique(mediaTablet); // 240_ stratis_galerie_classique.js
        searchState(mediaTablet); // 290_stratis_search.js
        filtersState(mediaTablet); // 300_stratis_filters.js
        carrousel1State(mediaTablet); // 330_stratis_carrousel1.js
        carrousel2State(mediaTablet); // 340_stratis_carrousel2.js
        carrousel3State(mediaTablet); // 350_stratis_carrousel5.js
        menuMain1State(mediaTablet);
    }

    function myInitFuncDesktop() {
        menuStratis(mediaDesktop); // 190_stratis_menu.js
        fancyboxGalerie(mediaDesktop); // 230_stratis_fancybox_galerie.js
        initGalerieClassique(mediaDesktop); // 240_stratis_galerie_classique.js
        searchState(mediaDesktop); // 290_stratis_search.js
        filtersState(mediaDesktop); // 300_stratis_filters.js
        carrousel1State(mediaDesktop); // 330_stratis_carrousel1.js
        carrousel2State(mediaDesktop); // 340_stratis_carrousel2.js
        carrousel3State(mediaDesktop); // 350_stratis_carrousel5.js
        menuMain1State(mediaDesktop);
    }

    // Generic functions
    preloadImages(); // 170_stratis_preload_images.js
    tooltipAccess(); // 200_stratis_tooltip.js
    tooltipDfn(); // 200_stratis_tooltip.js
    geocode(); // 205_stratis_geocode.js
    linkExternalNewWindow(); // 210_stratis_external_window.js
    fancyboxClassic(); // 220_stratis_fancybox_classic.js
    fancyboxAutoHome();  // 235_stratis_fancybox_auto_home.js
    sharePage(); // 250_stratis_share_page.js
    eventDdm(); // 260_stratis_event-ddm.js
    contentDdm(); // 270_stratis_content-ddm.js
    rightMenuDdm(); // 271_stratis_right-menu_ddm.js
    manageVideo(); // 280_stratis_video.js
    enableDatePicker(); // 310_stratis_datetimepicker.js
    enableTimePicker(); // 310_stratis_datetimepicker.js
    formValidation(); // 320_stratis_form_validation.js
    agendaDatePicker(); // 325_agenda_date-picker.js
    submitAgenda(); // 325_agenda_date-picker.js
    infiniteScroll(); // 350_stratis_infinite_scroll.js
    showTotal(); // 350_stratis_infinite_scroll.js
    catmenu(); // 355_stratis_catmenu.js
    faqDdm(); // 370_stratis_faq.js
    addContentInTitle(); // 380_stratis_add_in_title.js
    generatePie(); // 390_stratis_piechart.js
});

accessTooltipState(); // 400_stratis_access-tooltip.js

$(window).on('load', function () {
    var $list = $('.social-list'),
        $filterBtns = $('.filter-social [data-filter]');
    $list.isotope({
        itemSelector: 'li',
        masonry: {}
    });
    filter('.social-list-item');
    toggleActive($filterBtns.eq(0));
    $('.filter-social').on('click', 'button', function (e) {
        e.preventDefault();
        var $elem = $(this);
        filter($elem.attr('data-filter'));
        toggleActive($elem);
    });

    function filter(val) {
        $list.isotope({
            filter: val
        });
    }

    function toggleActive($elem) {
        deactivateAll();
        makeActive($elem);
    }

    function makeActive($elem) {
        $elem.addClass('active');
        $elem.append("<span class='ghost temporary'>" + l10n['tabsActiveText'] + "</span>");
    }

    function deactivateAll() {
        $filterBtns.removeClass('active');
        $filterBtns.find(".temporary").remove();
    }

    var figures = Array.prototype.slice.call(document.querySelectorAll('figure'));
    figures.forEach(function (figure) {
        var img = figure.querySelector('img');
        var caption = figure.querySelector('figcaption');
        if (caption && img && img.hasAttribute('alt')) {
            var alt = img.getAttribute('alt');
            img.setAttribute('alt', alt + ' - ' + l10n['seeCaption']);
        }
    });
});

$(window).on("resize load", function () {

    var windowWidth = $(window).width();
    var heroArrows = $('.hero .prevNextCarrousel1 li');
    var heroDots = $('.hero .pagerCarrousel1');
    var heroPlayPause = $('.hero .modeplay');
    var heroImage = $('.hero-carousel .cycle-slide-active .hero-carousel__image');

    if (windowWidth < 768) {

        heroArrows.css({
            "bottom": "auto",
            "top": heroImage.height() / 2 - heroArrows.height() / 2 + "px"
        });

        heroDots.css({
            "bottom": "auto",
            "top": heroImage.height() - heroDots.height() / 2 + 22 + "px"
        });

        heroPlayPause.css({
            "bottom": "auto",
            "top": heroImage.height() - heroDots.height() - 10 + "px"
        });
    } else {
        heroArrows.removeAttr('style');
        heroDots.removeAttr('style');
    }

});

document.addEventListener('DOMContentLoaded', function () {
    var powerMailForm = document.querySelector('.tx-powermail');

    setTimeout(function () {
        if (!powerMailForm) {
            return;
        }

        var formWithStep = powerMailForm.querySelector('.powermail_morestep');
        var sections = [].slice.call(powerMailForm.querySelectorAll('.powermail_fieldset'));

        // Mark the current section with the class 'current'
        function navigateTo(index) {
            sections.forEach(function (section, i) {
                return i === index
                    ? section.classList.add('current')
                    : section.classList.remove('current');
            });
        }

        // Return the current index by looking at which section has the class 'current'
        function curIndex() {
            var ind = null;

            sections.forEach(function (section, index) {
                if (section.classList.contains('current')) {
                    ind = index;
                }
            });

            return ind;
        }

        // Prepare sections by setting the `data-parsley-group` attribute to 'block-0', 'block-1', etc.
        function setAttributes() {
            sections.forEach(function (section, index) {
                var inputs = [].slice.call(section.querySelectorAll('input, select, textarea'));

                inputs.forEach(function (input) {
                    input.setAttribute('data-parsley-group', 'block-' + index);
                });
            });

            navigateTo(0);
        }

        function setAccessibility() {
            setTimeout(function() {
                var pageIndicator = document.querySelector('.index').parentElement;
                pageIndicator.setAttribute('aria-live', 'polite');
                pageIndicator.setAttribute('aria-atomic', 'true');
            }, 100)
        }

        setAccessibility();

        if (formWithStep) {
            setAttributes();

            // Next button goes forward iff current block validates
            var nextBtn = powerMailForm.querySelector('.button-1--next');

            nextBtn.addEventListener('click', function () {
                $('.powermail_form').parsley().whenValidate({
                    group: 'block-' + curIndex()
                }).done(function () {
                    navigateTo(curIndex() + 1);
                    setAccessibility();
                });
                setTimeout(function () {
                    var errorInput = powerMailForm.querySelectorAll('input.parsley-error, select.parsley-error, textarea.parsley-error')[0];

                    if (errorInput) {
                        errorInput.focus();
                    }

                }, 150);
            });
        }
    }, 0);
});
